import { useMemo } from 'react';
import { getRolePermissions, getRoleSlugs, hasRole, isAdmin } from '../utils/roleUtils';

/**
 * Custom hook for role-based permissions
 * @param {Object|null} operator - Operator object from auth context
 * @returns {Object} Role permissions and utility functions
 */
export const useRolePermissions = (operator) => {
  return useMemo(() => {
    const permissions = getRolePermissions(operator);
    const roleSlugs = getRoleSlugs(operator);
    
    return {
      ...permissions,
      roleSlugs,
      hasRole: (role) => hasRole(operator, role),
      isAdmin: isAdmin(operator),
      roleCount: roleSlugs.length,
      hasMultipleRoles: roleSlugs.length > 1,
    };
  }, [operator]);
};
